
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { UserService } from 'src/app/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manage-leads-admin',
  templateUrl: './manage-leads-admin.component.html',
  styleUrls: ['./manage-leads-admin.component.css']
})

export class ManageLeadsAdminComponent implements OnInit {
  leadsLst: any;
  prefix: string;
  selectedRows: number[];
  selectionChangedBySelectbox: boolean;
  checkBoxesMode: string;
  allMode: string;
  selectedItemKeys: any;
  status = [];
  temp = [];
  userDtls: any;
  rowKey: any = -1;
  email_id: any;
  old_mbl: any;
  popupVisible = false;
  user: any;
  usr_typ: any;
  lead_status: any;
  leadUsrLst: any;
  leadStatus: any;
  shwclient: boolean
  shwstatus: boolean;
  butDisabled: boolean = true;

  constructor(private http: HttpClient,
    private usrService: UserService,
    private toaster: ToastrService,
    public router: Router) {
    this.allMode = 'allPages';
    this.checkBoxesMode = 'onClick';
    // this.userDtls = JSON.parse(localStorage.getItem('userDetails'));

    if (!localStorage.getItem('userDetails')) {
      // alert("User Already Loged out , Please Login Again");
      this.router.navigate(["login-admin"]);
    } else {
      this.userDtls = JSON.parse(localStorage.getItem('userDetails'));
    }
    this.usr_typ = this.userDtls.userId;
    this.user = 0;
    this.lead_status = 0
  }

  ngOnInit() {
    this.usrService.leadslist().subscribe((res) => {
      this.leadUsrLst = res['data'];
    })

    this.usrService.leadsStatus().subscribe((res) => {
      this.leadStatus = res['data'];
    })
    this.getleads();
  }

  getleads() {
    this.usrService.allLeads(this.userDtls.userId).subscribe((res) => {
      this.leadsLst = res['data'];
    })
  }

  clntAsgn(sts) {
    if (this.selectedItemKeys && this.selectedItemKeys.length > 0) {
      if (sts == 1) {
        this.shwclient = true;
        this.shwstatus = false;
      } else if (sts == 2) {
        this.shwstatus = true;
        this.shwclient = false;
      }
    } else {
      this.toaster.success("please select atleast one item to perform action");
    }
  }
  selectionChanged(data: any) {
    console.log(data);
    this.selectedItemKeys = data.selectedRowKeys;
  }

  assignClient() {
    this.status = [];
    if (this.selectedItemKeys && this.selectedItemKeys.length > 0) {
      this.selectedItemKeys.forEach(element => {
        this.status.push(element.leadId);
      });
    }
    if (this.status.length > 0) {
      let mngeCtgry = {
        "adminId": this.userDtls.userId,
        "leadId": this.status,
        "assigendTo": parseInt(this.user)
      }
      console.log(mngeCtgry);
      this.usrService.leadsAssignTo(mngeCtgry).subscribe((udtRes) => {
        if (udtRes['code'] == 200) {
          this.toaster.success(this.status.length + ' ' + udtRes['message']);
          this.getleads();
          this.shwclient = false;
        }
      })
    }
  }

  changeLeadStatus() {
    this.status = [];
    if (this.selectedItemKeys && this.selectedItemKeys.length > 0) {
      this.selectedItemKeys.forEach(element => {
        this.status.push(element.leadId);
      });
    }
    if (this.status.length > 0) {
      let mngeCtgry = {
        "adminId": this.userDtls.userId,
        "leadId": this.status,
        "newStatus": parseInt(this.lead_status)
      }
      this.usrService.changeLeadStatus(mngeCtgry).subscribe((udtRes) => {
        if (udtRes['code'] == 200) {
          this.toaster.success(this.status.length + ' ' + udtRes['message']);
          this.getleads();
          document.getElementById("changeStatus").style.display = 'block' ? 'none' : 'block';
          setTimeout(() => {
            this.shwstatus = false;
          }, 100);
        }
      })
    }
  }
}

